import React from "react";
import {connect} from "react-redux";
import Title from "../../components/Title/Title";
import Icon from "../../components/Icon/Icon";
import Plate from "../../components/Plate/Plate";
import './RequestTerms.scss';
import {Form, Select, Spin, Input, Button, message} from "antd";
import {
  changeCustomerSumNeed,
  customerPeriodOnChange,
  setMaxLoan,
  changeCustomerLoanAction,
  saveCustomerInfoOld,
  calculateRequestOffer,
  editRequestTerms, 
  clearErrorMessage, 
  sendRequestToBank,
  saveLoanRequest,
  retailBehavioralOfferActivation,
  getRetailOffer
} from "../../reducers/applicationReducer";
import UserIncomes from "../UserIncomes/UserIncomes";
import IncomeCard from "../../components/IncomeCard/IncomeCard";
import UserIncomesList from "../UserIncomes/UserIncomesList";
import Collapsible from "react-collapsible";
import {Redirect} from "react-router-dom";
import NumericInput from "../../components/NumericInput/NumericInput";
import ErrorMessageContent from "../../components/ErrorMessageContent/ErrorMessageContent";
import moment from "moment";

class RequestTerms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rboBuildType: "0" 
    };
  }

  handleChange = (event) => {
    let data = {
      'amount': this.props.form.getFieldValue('sumNeed'),
      'action': this.props.dictionaries.actions.length !== 0 ? event : 0,
    }

    this.props.dispatch(setMaxLoan(data));
    this.props.dispatch(changeCustomerLoanAction({loan_action: event}));
    this.props.form.resetFields('period');
    
    this.forceUpdate();
  };

  handleRboChange = (event) => {
    this.setState({ rboBuildType: event });
  };

  handleBlur = (e) => {
    let data = {
      'amount': this.props.form.getFieldValue('sumNeed'),
      'action': this.props.dictionaries.actions.length !== 0 ? this.props.form.getFieldValue('buildType') : 0,
    }

    this.props.dispatch(setMaxLoan(data));
    this.props.form.resetFields('period');
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(['sumNeed', 'period'],(err, values) => {
      if (!err) {
        if (this.props.acba_status === 0 || this.props.acba_status === 9 || this.props.request_status === "edit" || this.props.request_status === "confirmed") {
          // this.props.dispatch(saveCustomerInfoOld(values.addInf));
          this.props.dispatch(saveLoanRequest(values.addInf));
        }
        else if (this.props.acba_status === 1 || (this.props.acba_status === 4 && this.props.request_status === "saved")) {
          this.props.dispatch(calculateRequestOffer());
        }
        else if ((this.props.acba_status === 4 && this.props.request_status !== "saved") || this.props.acba_status === 8) {
          this.props.dispatch(sendRequestToBank());
        }
      }
    })
  };


  handleRboSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(['usableCredit'], (err, values) => {
      if (!err) {
        const usableCredit = values.usableCredit;
        const terms = this.props.customer_info_for_save.request.rbo;
        
        if (terms && terms.duration === 60 && usableCredit < 200000) {
          message.error(<ErrorMessageContent text="Վարկային սահմանաչափը 60 ամիս ժամկետով է. սահմանաչափից օգտագործվող գումարը կարող է լինել նվազագույնը 200,000 ՀՀ դրամ։ Խնդրում ենք լրացնել ՆՈՐ ՀԱՅՏԻ ՏՎՅԱԼՆԵՐ հատվածը։" />, 5);
          return;
        }
        
        if (this.state.rboBuildType && this.state.rboBuildType !== "0") {
          this.props.dispatch(changeCustomerLoanAction({ loan_action: parseInt(this.state.rboBuildType) }));
        }
        this.props.dispatch(retailBehavioralOfferActivation(usableCredit));
      }
    })
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.request_status !== this.props.request_status && this.props.request_status === "calc_analyse_in_bank") {
      message.warning(<ErrorMessageContent text={this.props.calculate_request} />, 5);
    }
    if (this.props.error_message.type === "SaveFail" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
      message.error(<ErrorMessageContent text={this.props.error_message.message} />, 5);
      // this.props.dispatch(clearErrorMessage());
    }
    if (this.props.error_message.type === "SendToBank" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
      message.warning(<ErrorMessageContent text={this.props.error_message.message} />, 5);
      // this.props.dispatch(clearErrorMessage());
    }
    if (this.props.error_message.type === "CalculateRequestOffer" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
      message.error(<ErrorMessageContent text={this.props.error_message.message} />, 5);
    }
    if (this.props.error_message.type === "AuthenticationError" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
      message.error(<ErrorMessageContent text={this.props.error_message.message} />, 5);
    }
    if (this.props.error_message.type === "GetClearSalary" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
      message.error(<ErrorMessageContent text={this.props.error_message.message} />, 5);
    }
  }

  isRequestInputsDisabled = () => {
    if (this.props.request_status === "edit") {
      return false;
    } else {
      return this.props.request_status === "saved" || this.props.acba_status === 5 || this.props.acba_status === 6 || this.props.acba_status === 7
          || this.props.acba_status === 8 || this.props.acba_status === 9 || this.props.acba_status === 10 || this.props.acba_status === 99 ||
          this.props.acba_status === 100 || this.props.user_type == 3;
    }
  }

  isActionsButtonDisabled = () => {
    const {acba_status, request_status, user_type} = this.props;

    if ((acba_status === 9 && request_status === "edit")) {
      return false;
    }
    else if ((acba_status !== 1 && acba_status !== 4 && acba_status !== 8) || user_type == 3) { // պետք է միշտ լինի խմբագրելի Նոր, Թերի, Ենթակա է Բանկ ուղարկման կարգավիճակների դեպքում
      return true;
    } else {
      return false;
    }
  }

  isEditButtonDisabled = () => {
    const {request_status, acba_status, user_type} = this.props;

    if(this.props.customer_info_for_save.request.isRetailBehavioralOffer === true){
      return true;
    }
    if (user_type == 3) {
      return true;
    }
    else if (request_status === 'saved' || request_status === 'calc_analyse_in_bank'
        || acba_status === 1 || acba_status === 4 || acba_status === 8 || acba_status === 9) {
      return false;
    }
    else {
      return true;
    }
  }

  formatNumber = (number) => {
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };


  toPercentNoRound = (num) => {
    const scaled = Math.trunc((num * 100) * 1e12) / 1e12;
    return scaled;
  }


  formOnKeyDown = (e) => {
    return e.keyCode == 13 ? e.preventDefault(): '';
  };

  componentDidMount() {
     let requestID = this.props.customer_info_for_save.request.requestID;
     this.props.dispatch(getRetailOffer(requestID));
  }
  
  render() {
   
    let terms;
    let amount;

    if (this.props.acba_status === 0 || this.props.acba_status === 1) {
      terms = this.props.customer_info_for_save.request.rbo;
      if (terms !== undefined){
         amount = terms.limitAmountAMD !== undefined ? this.formatNumber(terms.limitAmountAMD) : "";
      }
    }

    const {addInf} = this.props.customer_info_for_save.request;
    const { getFieldDecorator } = this.props.form;
    
    return (
      <Spin spinning={(this.props.loading.type === "init_app_loading" && this.props.loading.loading_state) || (this.props.loading.type === "save_customer_loading" && this.props.loading.loading_state)} >


          {this.props.customer_info_for_save.request.rbo !== undefined &&
          (this.props.acba_status === 1 || this.props.acba_status === 0) &&
          terms.duration !== 0 &&
          terms.limitAmountAMD !== 0 &&
          (
          <div className="rbo-terms">
              <div className="rbo-terms__form">
                  <div className="flex-container row-wrap align-justify align-middle"> <Title text="Վարկային սահմանաչափի առաջարկ" size="lg" weight="bold" className="mb_40" /> </div>
                  <div className="row mb_30">
                    <div className="column small-12 medium-4">
                      <Plate label="Առաջարկի գումար" value={amount} type={<Icon type="dram" size={15} />} theme="green" />
                    </div>
                    <div className="column small-12 medium-4">
                      <Plate label="Տևողություն" value={terms.duration} type="ամիս" theme="grey" />
                    </div>
                    <div className="column small-12 medium-4">
                        {(() => {
                          const selectedActionId = this.state.rboBuildType;    
                          if (selectedActionId && selectedActionId !== "0") {
                            const selectedAction = this.props.dictionaries?.actions?.find(item => 
                              item.label?.id.toString() === selectedActionId
                            );
                            if (selectedAction && selectedAction.label && (selectedAction.label?.interestRateAfterGracePeriod != null || selectedAction.label?.interestRateInGracePeriod != null || selectedAction.label?.interestRateRepaymentGracePeriod != null || selectedAction.label?.principalRepaymentGracePeriod != null)) {
                              return (
                                <div className="action-result">
                                  <div className="action-name">{selectedAction.label.name}</div>
                                  {selectedAction.label.start && selectedAction.label.end && (
                                    <div className="action-date"><Icon type="date" size={10}/>{moment(selectedAction.label.start).format('DD/MM/YYYY')} - {moment(selectedAction.label.end).format('DD/MM/YYYY')}</div>
                                  )}
                                  {(selectedAction.label?.interestRateAfterGracePeriod != null || selectedAction.label?.interestRateInGracePeriod != null || selectedAction.label?.interestRateRepaymentGracePeriod != null || selectedAction.label?.principalRepaymentGracePeriod != null) && (
                                     <div className="action-infos">
                                        {selectedAction.label?.principalRepaymentGracePeriod != null && (
                                          <div className="action-info"><Icon type="done" size={8}/>
                                            {selectedAction.label.principalRepaymentGracePeriod} ամիս միայն տոկոսի մարում
                                          </div>
                                        )}
                                        {selectedAction.label?.principalRepaymentGracePeriod != null && (
                                          <div className="action-info"><Icon type="done" size={8}/>
                                            Հաջորդ ամիսներին՝ ամսական հավասարաչափ
                                          </div>
                                        )}
                                        {selectedAction.label?.interestRateRepaymentGracePeriod != null && selectedAction.label?.interestRateInGracePeriod != null && (
                                          <div className="action-info"><Icon type="done" size={8}/>
                                            1-{selectedAction.label.interestRateRepaymentGracePeriod} ամիս՝ {this.toPercentNoRound(selectedAction.label.interestRateInGracePeriod)}%
                                          </div>
                                        )}
                                        {selectedAction.label?.interestRateAfterGracePeriod != null && (
                                          <div className="action-info"><Icon type="done" size={8}/>
                                            Հաջորդ ամիսներին՝ {this.toPercentNoRound(selectedAction.label.interestRateAfterGracePeriod)}%
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </div>
                              );
                            }
                          }
                          return null;
                        })()}
                    </div>
                  </div>
                  <Form
                    onKeyDown={this.formOnKeyDown}
                    onSubmit={this.handleRboSubmit}
                    className="row"
                  >
                    <Form.Item label="Սահմանաչափից օգտագործվող գումար" className="column small-12 large-4">
                        {getFieldDecorator('usableCredit', {
                          rules: [{ required: true, message: 'դաշտը լրացված չէ' }],
                        })(
                        <NumericInput
                        suffix={<Icon type="dram" size={13}/>}
                        formatter={value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                        />
                      )}
                    </Form.Item>
                    {this.props.dictionaries.actions.length !== 0 &&
                    <Form.Item label="Արշավ" className="column small-12 large-4">
                          <Select
                            value={this.state.rboBuildType}
                            disabled={this.isRequestInputsDisabled()}
                            onChange={this.handleRboChange}
                            showSearch
                            optionLabelProp="label"
                          >
                            <Select.Option style={{paddingBottom: 25}} value="0" label="">

                            </Select.Option>
                          
                            {
                              this.props.dictionaries?.actions?.length                            
                                 ? this.props.dictionaries.actions
                                    .filter((item) => item.label?.showInOffers === true)
                                    .map((item) => (
                                    <Select.Option 
                                      key={item.label?.id.toString()} 
                                      value={item.label?.id.toString()}
                                      label={item.label?.name || ""}
                                    >
                                    {item.label?.name && <div className="action-name">{item.label.name}</div>}
                                    </Select.Option>
                                  ))
                                : null
                            }
                          </Select>
                    </Form.Item>
                    }
                    <div className="column small-12">
                      <div
                        className="flex-container align-middle align-justify"
                      >
                        {terms && terms.duration === 60 &&
                          <div className="rbo-info">
                            <div className="rbo-info__icon">
                              <img src={require('../../assets/img/info.svg')} alt="info" />
                            </div>
                            <span>Սահմանաչափից օգտագործվող նվազագույն գումար՝ 200,000 ՀՀ դրամ</span>
                          </div>}
                        <Form.Item className="text-right md-text-center m_0 ml_auto">
                          <Button
                            className="btn btn_group"
                            htmlType="submit"
                            loading={ this.props.loading.loading_state && this.props.loading.type === "rbo_offer_activation" }
                          >
                            <span>ՕԳՏԱԳՈՐԾԵԼ</span>
                            <span className="btn__icon">
                              <Icon type="next" size={22} />
                            </span>
                          </Button>
                        </Form.Item>
                      </div>
                    </div>
                  </Form>
              </div>
              <div className="rbo-terms__text">Բանկի կողմից առաջարկվող սահմանաչափի գումարը բավարար չլինելու դեպքում լրացնել նոր հայտ</div>
          </div>
        )}


        <div className="flex-container row-wrap align-justify align-middle">
          <Title text="ՆՈՐ ՀԱՅՏԻ ՏՎՅԱԼՆԵՐ" size="lg" weight="bold" className="mb_40"/>
          {/*Հայտը թույլատրվում է պահպանել միայն Նոր, Թերի, Ենթակա է բանկ ուղարկման, Սահմանաչափի առաջարկ կարգավիճակների դեպքում*/}
          <Button
            disabled={this.isEditButtonDisabled()}
            type="link" className="link_btn"
            onClick={() => {this.props.dispatch(editRequestTerms())}}
          >
            <Icon type="pen" size={13} />
            ԽՄԲԱԳՐԵԼ ՏՎՅԱԼՆԵՐԸ
          </Button>
        </div>

        <Form onKeyDown={this.formOnKeyDown} onSubmit={this.handleSubmit} className="row">

          <Form.Item label="Վարկի ցանկալի գումար" className="column small-12 large-4">
            {getFieldDecorator('sumNeed', {
              initialValue: this.props.customer_info_for_save.request.startCapital !== "" ? this.props.customer_info_for_save.request.startCapital : "",
              rules: [
                {required: true, message: 'դաշտը լրացված չէ'},
              ],
            })(
              <NumericInput
                suffix={<Icon type="dram" size={13}/>}
                formatter={value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                onChange={(value) => this.props.dispatch(changeCustomerSumNeed({sum_need: value}))}
                onBlur={this.handleBlur}
                disabled={this.isRequestInputsDisabled()}
              />
            )}
          </Form.Item>

          <Form.Item label="Տևողություն" className="column small-12 large-4">
            {
              getFieldDecorator('period', {
                getValueFromEvent: (e) => {
                  const convertedValue = Number(e.currentTarget.value);
                  if (isNaN(convertedValue)) {
                    return Number(this.props.form.getFieldValue("period"));
                  } else {
                    return convertedValue === 0 ? "" : convertedValue;
                  }
                },
                rules: [
                  {required: true, message: 'դաշտը լրացված չէ',},
                  {
                    max: this.props.max_loan,
                    message: `Ժամկետը գերազանցում է թույլատրելի առավելագույն չափը ${this.props.max_loan} ամիսը`,
                    type: "number"
                  },
                ],
                initialValue: this.props.period
              })
              (
                  <Input
                      type="number"
                      name="period"
                      suffix="ամիս"
                      onChange={(e) => this.props.dispatch(customerPeriodOnChange({period: e.target.value}))}
                      disabled={this.isRequestInputsDisabled()}
                      autoComplete="off"
                  />
              )
            }
          </Form.Item>

          {this.props.dictionaries.actions.length !== 0 &&
          <Form.Item label="Արշավ" className="column small-12 large-4">
            {getFieldDecorator('buildType', {
              initialValue: (this.props.loading.loading_state && this.props.loading.type === "rbo_offer_activation") ? "0" : (this.props.customer_info_for_save.request.action !== "" ? this.props.customer_info_for_save.request.action.toString() : "0"),
              rules: [{required: false, message: ''}],
            })(
                <Select
                  disabled={this.isRequestInputsDisabled()}
                  onChange={this.handleChange}
                  showSearch
                  optionLabelProp="label"
                >
                  <Select.Option style={{paddingBottom: 25}} value="0" label="">

                  </Select.Option>
                  {
                    this.props.dictionaries?.actions?.length
                      ? this.props.dictionaries.actions
                          .map((item) => (
                          <Select.Option 
                            key={item.label?.id.toString()} 
                            value={item.label?.id.toString()}
                            label={item.label?.name || ""}
                          >
                           {item.label?.name && <div className="action-name">{item.label.name}</div>}
                          </Select.Option>
                        ))
                      : null
                  }
                </Select>
            )}
          </Form.Item>
          }

          <div className="column small-12 large-4"></div>
          <div className="column small-12 large-4"></div>

          {this.props.dictionaries.actions.length !== 0 && (
            <div className="column small-12 large-4">
                {(() => {
                  const selectedActionId = this.props.form.getFieldValue('buildType');    
                  if (selectedActionId && selectedActionId !== "0") {
                    const selectedAction = this.props.dictionaries?.actions?.find(item => 
                      item.label?.id.toString() === selectedActionId
                    );
                    if (selectedAction && selectedAction.label && (selectedAction.label?.interestRateAfterGracePeriod != null || selectedAction.label?.interestRateInGracePeriod != null || selectedAction.label?.interestRateRepaymentGracePeriod != null || selectedAction.label?.principalRepaymentGracePeriod != null)) {
                      return (
                        <div className="action-result">
                          <div className="action-name">{selectedAction.label.name}</div>
                          {selectedAction.label.start && selectedAction.label.end && (
                            <div className="action-date"><Icon type="date" size={10}/>{moment(selectedAction.label.start).format('DD/MM/YYYY')} - {moment(selectedAction.label.end).format('DD/MM/YYYY')}</div>
                          )}
                          {(selectedAction.label?.interestRateAfterGracePeriod != null || selectedAction.label?.interestRateInGracePeriod != null || selectedAction.label?.interestRateRepaymentGracePeriod != null || selectedAction.label?.principalRepaymentGracePeriod != null) && (
                             <div className="action-infos">
                                {selectedAction.label?.principalRepaymentGracePeriod != null && (
                                  <div className="action-info"><Icon type="done" size={8}/>
                                    {selectedAction.label.principalRepaymentGracePeriod} ամիս միայն տոկոսի մարում
                                  </div>
                                )}
                                {selectedAction.label?.principalRepaymentGracePeriod != null && (
                                  <div className="action-info"><Icon type="done" size={8}/>
                                    Հաջորդ ամիսներին՝ ամսական հավասարաչափ
                                  </div>
                                )}
                                {selectedAction.label?.interestRateRepaymentGracePeriod != null && selectedAction.label?.interestRateInGracePeriod != null && (
                                  <div className="action-info"><Icon type="done" size={8}/>
                                    1-{selectedAction.label.interestRateRepaymentGracePeriod} ամիս՝ {this.toPercentNoRound(selectedAction.label.interestRateInGracePeriod)}%
                                  </div>
                                )}
                                {selectedAction.label?.interestRateAfterGracePeriod != null && (
                                  <div className="action-info"><Icon type="done" size={8}/>
                                    Հաջորդ ամիսներին՝ {this.toPercentNoRound(selectedAction.label.interestRateAfterGracePeriod)}%
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      );
                    }
                  }
                  return null;
                })()}
            </div>
          )}

      

          <div className="column small-12 mt_10">
            <div className="flex-container row-wrap align-justify align-middle mb_40">
              {this.props.request_status === "edit" || this.props.user_incomes.length !== 0 ?
                <Title text="ՀԱՃԱԽՈՐԴԻ ԵԿԱՄՈՒՏՆԵՐ" icon="dram" iconSize={18} size="lg" weight="bold"/>
                : null
              }
              {/*{(this.props.request_status === "edit" && this.props.acba_status !== 1) &&*/}
              {this.props.request_status === "edit" &&
                <UserIncomes />
              }
            </div>
          </div>

          <div className="column small-12 mb_30">
            {this.props.user_incomes.length !== 0 ?
              this.props.user_incomes.map((element,index) => {
                let work_profit_type = this.props.dictionaries.work_profit_type.find((index) => (index.value == element.profitType));
                let work_reference_type = {};
                if (this.props.income_temp_dictionary.work_reference_type[index] !== undefined) {
                  let temp_work_reference_type = this.props.income_temp_dictionary.work_reference_type[index].find((index) => index.value == element.referenceType);
                  if(temp_work_reference_type === undefined){
                    work_reference_type.label = "";
                  }
                  else {
                    work_reference_type = temp_work_reference_type;
                  }
                } else {
                  work_reference_type.label = "";
                }

                let text;
                if ((work_profit_type.label !== undefined && work_profit_type.label != null && work_profit_type.label !== "") &&
                    (work_reference_type.label !== undefined && work_reference_type.label != null && work_reference_type.label !== "")) {
                  if (element.money !== undefined) {
                    text = work_profit_type.label + ', ' + work_reference_type.label + '` ' + this.formatNumber(element.money);
                  } else {
                    text = work_profit_type.label + ', ' + work_reference_type.label;
                  }
                }
                else {
                  text = element.money !== undefined ? this.formatNumber(element.money) : "";
                }

                if (element.money) { // if clearMoney is calculated -> render the card
                  return (
                    <IncomeCard text={text} key={index} income_index={index} />
                  )
                }
              })
              :
              null
            }
          </div>

          {
            (this.props.request_status === "edit" || addInf) &&
              <div className="column small-12 mb_30" >
                <Collapsible
                  trigger={<Title text="ԼՐԱՑՈՒՑԻՉ ՏՎՅԱԼՆԵՐ" icon="info" size="lg" weight="bold" />}
                  triggerTagName="div"
                  open={this.props.acba_status == 4 && this.props.customer_info_for_save.request.addInf}
                >
                  <div className="panel_inner">
                    <Form.Item>
                      {getFieldDecorator('addInf', {
                        initialValue: this.props.customer_info_for_save.request.addInf,
                        rules: [{ required: false, message: '' }],
                      })(
                        <Input.TextArea style={{minHeight: "60px"}} />
                      )}
                    </Form.Item>
                  </div>
                </Collapsible>
              </div>
          }

          {(this.props.request_status === "confirmed" || this.props.acba_status === 0) ?
            <div className="column small-12">
              <div className="flex-container align-middle align-justify" style={{justifyContent: "flex-end"}}>
                <Form.Item className="text-right md-text-center m_0">
                  <Button
                    className="btn btn_group"
                    htmlType="submit"
                    loading={this.props.loading.loading_state && this.props.loading.type === "save_customer_loading"}
                  >
                    <span>ՊԱՀՊԱՆԵԼ</span>
                    <span className="btn__icon">
                  <Icon type="microcard" size={22} />
                </span>
                  </Button>
                </Form.Item>
              </div>
            </div>
            :
            <div className="column small-12">
              <div className="flex-container align-middle align-justify" style={{justifyContent: "flex-end"}}>
                <Form.Item className="text-right md-text-center m_0">
                  <Button
                      className="btn btn_group"
                      htmlType="submit"
                      disabled={this.isActionsButtonDisabled()}
                      loading={this.props.loading.loading_state && (this.props.loading.type === "save_customer_loading" || this.props.loading.type === "send_to_bank")}
                  >
                    {(this.props.request_status === "edit" || (this.props.acba_status !== 1 && this.props.acba_status !== 2 && this.props.acba_status !== 4 &&  this.props.acba_status !== 8)) && <span>ՊԱՀՊԱՆԵԼ</span>}
                    {((this.props.acba_status === 1 && this.props.request_status !== "edit") || (this.props.acba_status === 4 && this.props.request_status === "saved")) && <span>ՀԱՇՎԱՐԿԵԼ</span>}
                    {(((this.props.acba_status === 4 && this.props.request_status !== "saved") || this.props.acba_status === 8) && this.props.request_status !== "edit") && <span>Ուղարկել Բանկ</span>}
                    {(this.props.acba_status === 2) && <span>Ուղարկված</span>}
                    <span className="btn__icon">
                     <Icon type="calc" size={22} />
                    </span>
                  </Button>
                </Form.Item>
              </div>
            </div>
          }
        </Form>
      </Spin>
    )
  }
}

function mapStateToProps(state) {
  return {
    user_type: state.initReducer.user_type,
    dictionaries: state.applicationReducer.dictionary,
    income_temp_dictionary: state.applicationReducer.income_temp_dictionary,
    request_status: state.applicationReducer.request_status,
    acba_status: state.applicationReducer.acba_status,
    customer_info_for_save: state.applicationReducer.customer_info_for_save,
    period: state.applicationReducer.period,
    max_loan: state.applicationReducer.max_loan,
    calculate_request: state.applicationReducer.calculate_request,
    user_incomes: state.applicationReducer.customer_info_for_save.request.personWorkInfList,
    loading: state.applicationReducer.loading,
    agreementPDF: state.applicationReducer.agreementPDF,
    error_message: state.applicationReducer.error_message,
  }
}

const RequestTermsContainer = Form.create()(RequestTerms);

export default connect(mapStateToProps)(RequestTermsContainer);
